import { render } from "./CodeEditor.vue?vue&type=template&id=369bb5fd&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=369bb5fd&lang=css"
import "./CodeEditor.vue?vue&type=style&index=1&id=369bb5fd&scoped=true&lang=css"
import "./CodeEditor.vue?vue&type=style&index=2&id=369bb5fd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369bb5fd"]])

export default __exports__